import { colors } from "@mui/material";
import { theme } from "@ssf/components";
import { CheckValuesType, MemdbBoolean } from "@ssf/memdb-api";
const checkValuesStrings = [
    "ConstituentMeeting",
    "AnnualMeeting",
    "AnnualReport",
    "Members",
];
const checkValues = checkValuesStrings.map((str) => CheckValuesType[str]);
export const getIssues = ({ clubStatus = [], contenderIssues = [], isClubApproved, }) => [
    { name: "clubUnapproved", approved: isClubApproved },
    ...getClubIssues(clubStatus),
    ...getContenderIssues(contenderIssues),
];
export const getClubIssues = (approvalStatus) => approvalStatus
    .filter(({ referenceid }) => checkValues.includes(referenceid))
    .map(({ referenceid, ...clubCheck }) => ({
    name: CheckValuesType[referenceid],
    ...clubCheck,
}));
export const getContenderIssues = (contenderIssues) => contenderIssues.map((issue) => {
    const [name, status = "unapproved", count, preferredCount] = issue.split(":");
    return {
        name,
        approved: status !== "unapproved",
        signed: false,
        count: count ? Number.parseInt(count) : undefined,
        preferredCount: preferredCount
            ? Number.parseInt(preferredCount)
            : undefined,
    };
});
export const getIssuesColor = (issues, club) => {
    const isSchoolclub = club?.schoolclub === MemdbBoolean.True;
    const isActive = club?.active === MemdbBoolean.True;
    const isNoEconomy = club?.noeconomy === MemdbBoolean.True;
    const color = !isSchoolclub || !isActive
        ? "grey"
        : issues.every(({ approved }) => approved)
            ? "green"
            : "yellow";
    const htmlColor = getIssuesHtmlColor(color);
    return { color, htmlColor, isSchoolclub, isActive, isNoEconomy };
};
export const getIssuesSortOrder = (issues, club) => {
    const isSchoolclub = club?.schoolclub === MemdbBoolean.True;
    const isActive = club?.active === MemdbBoolean.True;
    const sortOrder = !isSchoolclub || !isActive
        ? 0
        : issues.every(({ approved }) => approved)
            ? 2
            : 1;
    return sortOrder;
};
export const getIssuesHtmlColor = (color) => color === "grey"
    ? theme.palette.text.disabled
    : color === "green"
        ? colors.green[500]
        : colors.yellow[800];
//# sourceMappingURL=getIssues.js.map